import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "mfm_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (item) => setItems((prev) => [...prev, { ...item, _key: Date.now() + Math.random() }]);
  const removeItem = (key) => setItems((prev) => prev.filter((i) => i._key !== key));
  const clear = () => setItems([]);

  const count = items.length;
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
